import React, { useEffect, useState } from "react";
import CandidateInterviewScheduler from "../../../../Common/Calendar-Scheduler/CandidateInterviewScheduler";
import {
  VYLABS_BASE_URL,
  GET_CANDIDATE_BY_ID,
} from "../../../../helper/url_helper";
import { get } from "../../../../helper/Api_helper";
const CalendarPage = (candidate) => {
  const [hasApplicationIds, setHasApplicationIds] = useState(false);
  const [validApplicationId, setValidApplicationId] = useState(null);
  const fetchCandidateById = async () => {
    try {
      const canididateID = candidate?.candidate?.id;
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_BY_ID}?id=${canididateID}`
      );
      if (response?.candidate?.application_ids?.length > 0) {
        setValidApplicationId(response.candidate.application_ids[0]);
        setHasApplicationIds(true);
      }
    } catch (error) {
      console.error("Error fetching candidate:", error);
    }
  };
  useEffect(() => {
    fetchCandidateById();
  }, []);
  return (
    <CandidateInterviewScheduler
      applicationId={validApplicationId}
      hasApplicationIds={hasApplicationIds}
      events
      defaultView="week"
      height="600px"
      selectable={true}
      candidateDetails={candidate}
      onSelectEvent
      onSelectSlot
      headerClassName="candidate-interview-header"
    />
  );
};

export default CalendarPage;
